import {AConfig} from "./AConfig";
import {appInjector} from "../classes/appInjector";
import {ToolsService} from "../services/toolsService/tools.service";
import {MapPosition} from "./MapPosition";
import {Subject} from "rxjs";
declare var google;

export class ObjectConfig extends AConfig {

  static readonly TYPE_POINT = 'point';
  static readonly TYPE_POLYLINE = 'polyline';
  static readonly TYPE_POLYGON = 'polygon';
  static readonly TYPE_FIXED_FIGURE = 'fixed-figure';
  static readonly TYPE_CIRCLE = 'circle';

  private tool_id = null;
  private tool_type = null;
  private icon = null;
  private map_icon = null;
  private position = null;
  private center = null;
  private _fillColor = null;
  private fillOpacity = null;
  private strokeColor = null;
  private strokeOpacity = null;
  private strokeWeight = null;
  private radius = null;
  private latLngs = null;
  private bounds = null;
  private length = null;
  private area = null;
  private rotation:number = 0;
  private _prevRotation:number = 0;
  private fixed_width = null;
  private fixed_width_px = null;
  private fixed_height = null;
  private fixed_scale = null;
  private icon_config = null;
  private icon_config_svg = null;
  private offset = null;
  private repeat = null;
  private offset_type = null;
  private repeat_type = null;
  private dashWidthInMeters = null;
  private importantOpacity = null;


  private _oldConfigHash = null;
  private isSilentOnes = false;

  public _subject : Subject<ObjectConfig> = new Subject<ObjectConfig>();
  get subject(){
    return this._subject.asObservable();
  }
  public _serverUpdate : Subject<ObjectConfig> = new Subject<ObjectConfig>();
  get serverUpdate(){
    return this._serverUpdate.asObservable();
  }

  constructor(config?, isWithoutSave?) {
    super();
    if (config) {
      this.assign(config, isWithoutSave);
    }
  }

  public isValid() {
    if (this.tool_type === ObjectConfig.TYPE_POLYLINE || this.tool_type === ObjectConfig.TYPE_POLYGON) {
      const positions: MapPosition[] = this.getPositions();
      if (positions.length < 2) {
        return false;
      }
      if (positions[0].lat === null || isNaN(positions[0].lat)) {
        return false;
      }
    }
    return true;
  }

  public setData(key:string, value:any, isSilent?:boolean) {
    if (isSilent) {this.isSilentOnes = true}
    if (key === 'fixed_width') { value = parseFloat(value); }
    if (key === 'fixed_height') { value = parseFloat(value); }
    this[key] = value;
    this.onChange();
  }

  /**
   * Legacy method for calculations
   * @deprecated
   */
  public getPath() {
    return this.getPositions().map((p: MapPosition) => p.asGoogleMapsLatLng());
  }

  /**
   * Legacy method for calculations
   * @deprecated
   */
  public getHumanizedPosition() {
    return (this.getPosition()) ? this.getPosition().asGoogleMapsLatLng() : null;
  }

  // /**
  //  * Legacy method for calculations
  //  * @deprecated
  //  */
  // get position() {
  //   return (this.getPosition() ? this.getPosition().asGoogleMapsLatLng() : (new MapPosition({lat: 0, lng: 0}).asGoogleMapsLatLng()));
  // }

  public getCenterPosition(){
    let center = this.getPosition();
    if (center) return center;
    let positions = this.getPositions();
    if (positions.length == 0){
      return null;
    }
    // @ts-ignore
    center = positions.reduce((acc:any, currentVal:any)=>{
      return {latitude: acc.latitude + (currentVal.lat || currentVal.latitude), longitude: acc.longitude + (currentVal.lng || currentVal.longitude)}
    });
    center.latitude = center.latitude/this.getPositions().length;
    center.longitude = center.longitude/this.getPositions().length;
    delete center.height;
    return new MapPosition(center);
  }

  public getToolType() {
    return this.tool_type;
  }

  public getMapIcon(){
    return this.map_icon;
  }

  public setMapIcon(value){
    this.setData('map_icon', value);
  }

  public getMenuIcon(){
    return this.getTool().menu_icon;
  }

  public getFixedSize() {
    return {fixed_height: this.fixed_height, fixed_width: this.fixed_width, fixed_width_px: this.fixed_width_px};
  }

  public getFixedScale(){
    return this.fixed_scale || 1;
  }

  public hasFixedSize(){
    return (this.fixed_height || this.fixed_width);
  }

  public getFixedWidth() {
    return this.getFixedSize().fixed_width;
  }

  public getFixedWidthPx() {
    return this.getFixedSize().fixed_width_px;
  }

  public getFixedHeight(){
    return this.getFixedSize().fixed_height
  }

  public getPrevRotation(){
    return this._prevRotation;
  }

  setPrevRotation(value){
    this._prevRotation = value;
  }

  public setRotation(value){
    this._prevRotation = this.rotation;
    this.setData('rotation', value);
  }

  public getRotation() {
    return this.rotation;
  }

  public getStrokeColor(){
    return this.strokeColor;
  }
  public getStrokeWeight(){
    return this.strokeWeight;
  }

  get fillColor(): string {
    return this._fillColor;
  }

  set fillColor(val: string) {
    this.setData('_fillColor', val);
    // this._fillColor = val;
  }

  public getFillOpacity(){
    return this.fillOpacity;
  }
  public getImportantFillOpacity(){
    return this.importantOpacity;
  }

  public setFillOpacity(val){
    this.setData('fillOpacity', val);
  }

  public setDashWidthInMeters(val, silent?){
    this.dashWidthInMeters = val;
    if (silent){
     return;
    }
    this.setData('dashWidthInMeters', val);
  }

  public getDashWidthInMeters(){
    return (this.dashWidthInMeters) ? parseFloat(this.dashWidthInMeters) : null;
  }

  public getTool() {
    return appInjector.get(ToolsService).getToolById(this.tool_id);
  }

  setPosition(position : MapPosition){
    this.setData('position', position.asSimpleObject());
  }

  public getPosition(){
    return (this.position && !Array.isArray(this.position)) ? (new MapPosition(this.position)) : null;
  }
  public getCenter(){return (this.center ? (new MapPosition(this.center)) : null);}
  public getRadius(){return this.radius;}

  setPositions(positions){
    this.setLatLngs(positions.map((pos)=>{
      return new MapPosition(pos);
    }));
  }

  setLatLngs(positions : MapPosition[]) {
    this.setData('latLngs', positions.map((p : MapPosition) => p.asSimpleObject()));
  }

  setRadius(val){
    this.setData('radius', val);
  }

  setCenter(val){
    this.setData('center', val);
  }

  public getPositions():MapPosition[]{
    // @ts-ignore
    return (this.latLngs && Array.isArray(this.latLngs)) ? this.latLngs.map(latLng => new MapPosition(latLng)) : [];
  }

  public getRawPositions():[]{
    // @ts-ignore
    return this.latLngs;
  }

  public assign(config, withoutOldConfig?) {
    if (config instanceof ObjectConfig) {
      this.tool_id = config.tool_id;
      this.tool_type = config.tool_type;
      this.icon = config.icon;
      if (config.map_icon) {
        this.map_icon = config.map_icon;
      } else if (config.hasOwnProperty('icon') && config.icon && config.icon.hasOwnProperty('url')) {
        this.map_icon = config.icon.url;
      }
      this.position = config.position;
      this.center = config.center;
      this._fillColor = config.fillColor;
      this.fillOpacity = config.fillOpacity;
      this.strokeColor = config.strokeColor;
      this.strokeWeight = config.strokeWeight;
      this.radius = config.radius;
      this.latLngs = config.latLngs;
      this.bounds = config.bounds;
      this.length = config.length;
      this.area = config.area;
      this.rotation = config.rotation;
      this.fixed_width = this.getFloatValue(config.fixed_width);
      this.fixed_width_px = this.getFloatValue(config.fixed_width_px);
      this.fixed_height = this.getFloatValue(config.fixed_height);
      this.fixed_scale = config.fixed_scale;
      this.icon_config = config.icon_config;
      this.icon_config_svg = config.icon_config_svg;
      this.offset = config.offset;
      this.repeat = config.repeat;
      this.offset_type = config.offset_type;
      this.repeat_type = config.repeat_type;
      this.importantOpacity = config.importantOpacity || null;
      this.dashWidthInMeters = config.dashWidthInMeters || this.dashWidthInMeters || null;
      this._prevRotation = config.rotation;
    }
    else {
      if (config.hasOwnProperty('tool_id')) { this.tool_id = config.tool_id; }
      if (config.hasOwnProperty('tool_type')) { this.tool_type = config.tool_type; }
      if (config.hasOwnProperty('icon')) { this.icon = config.icon; }
      if (config.hasOwnProperty('map_icon')) { this.map_icon = config.map_icon; }
      else if (config.hasOwnProperty('icon') &&  config.icon.hasOwnProperty('url')) { this.map_icon = config.icon.url; }
      if (config.hasOwnProperty('position')) { this.position = config.position; }
      if (config.hasOwnProperty('originalPosition')) { this.position = config.originalPosition; }
      if (config.hasOwnProperty('center')) { this.center = config.center; }
      if (config.hasOwnProperty('fillColor')) { this._fillColor = config.fillColor; }
      if (config.hasOwnProperty('fillOpacity')) { this.fillOpacity = config.fillOpacity; }
      if (config.hasOwnProperty('strokeColor')) { this.strokeColor = config.strokeColor; }
      if (config.hasOwnProperty('strokeWeight')) { this.strokeWeight = config.strokeWeight; }
      if (config.hasOwnProperty('radius')) { this.radius = config.radius; }
      if (config.hasOwnProperty('latLngs')) { this.latLngs = config.latLngs; }
      if (config.hasOwnProperty('bounds')) { this.bounds = config.bounds; }
      if (config.hasOwnProperty('length')) { this.length = config.length; }
      if (config.hasOwnProperty('area')) { this.area = config.area; }
      if (config.hasOwnProperty('rotation')) { this.rotation = config.rotation; this._prevRotation = config.rotation; }
      if (config.hasOwnProperty('fixed_width')) { this.fixed_width = this.getFloatValue(config.fixed_width); }
      if (config.hasOwnProperty('fixed_width_px')) { this.fixed_width_px = this.getFloatValue(config.fixed_width_px); }
      if (config.hasOwnProperty('fixed_height')) { this.fixed_height = this.getFloatValue(config.fixed_height); }
      if (config.hasOwnProperty('fixed_scale')) { this.fixed_scale = config.fixed_scale; }
      if (config.hasOwnProperty('icon_config')) { this.icon_config = config.icon_config; }
      if (config.hasOwnProperty('icon_config_svg')) { this.icon_config_svg = config.icon_config_svg; }
      if (config.hasOwnProperty('offset')) { this.offset = config.offset; }
      if (config.hasOwnProperty('repeat')) { this.repeat = config.repeat; }
      if (config.hasOwnProperty('offset_type')) { this.offset_type = config.offset_type; }
      if (config.hasOwnProperty('repeat_type')) { this.repeat_type = config.repeat_type; }
      if (config.hasOwnProperty('dashWidthInMeters')) { this.dashWidthInMeters = config.dashWidthInMeters; }
      if (config.hasOwnProperty('importantOpacity')) { this.importantOpacity = config.importantOpacity; }
    }
    this.updateRepotsOptions();

    if (!withoutOldConfig){
      this.initializeOldConfig();
    }
    this._serverUpdate.next(this);
  }

  private getFloatValue(value: any, defaultValue: number = null) {
    let parsed = parseFloat(value);
    if (isNaN(parsed)) {
      return defaultValue;
    }
    return parsed;
  }

  public asJSON() {
    const obj1 = JSON.parse(JSON.stringify(this, (k, v) => {
      if (k === '_oldConfigHash') {return undefined;}
      if (k === '_subject') {return undefined;}
      if (k === 'subject') {return undefined;}
      if (k === '_serverUpdate') {return undefined;}
      if (k === 'serverUpdate') {return undefined;}
      if (k === '_prevRotation') {return undefined;}
      return v;
    }));
    obj1.fillColor = obj1._fillColor;
    return JSON.stringify(obj1);
  }

  public asSimpleObject() : Object {
    return JSON.parse(this.asJSON());
  }

  protected initializeOldConfig() {
    this._oldConfigHash = this.asJSON();
  }

  private updateRepotsOptions(){
    let pos = [];
    this.getPositions().forEach((item:MapPosition, index,arr)=>{
      pos.push(Cesium.Cartographic.fromDegrees(item.longitude, item.latitude, item.height));
    });
    let path = this.getPositions().map((p: MapPosition) => p.asSimpleObject());
    this.bounds = Cesium.Rectangle.fromCartographicArray(pos);
    try {
      this.length = path ? google.maps.geometry.spherical.computeLength(path) : null;
    } catch (e) {
      this.length = null;
    }
    if (this.tool_type === 'polygon') {
      try {
        this.area = path ? google.maps.geometry.spherical.computeArea(path) : null;
      } catch (e) {
        this.area = null;
      }
    } else {
      this.area = null;
    }
  }

  protected onChange() {
    // prevent save to server
    if (this.isSilentOnes) {
      this.isSilentOnes = false;
      return;
    }

    if (this._oldConfigHash !== null) {
      this.updateRepotsOptions();

      const newConfigHash = this.asJSON();
      if (this._oldConfigHash !== newConfigHash) {
        this._oldConfigHash = newConfigHash;
        this._subject.next(this);
      }
    }
  }
}


